(() => {
  const formatDate = (date) =>
    new Intl.DateTimeFormat('en-IN', {
      day: 'numeric',
      month: 'short',
    }).format(date);

  const formatMoney = (cents) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);

  const addDays = (start, days) => {
    const result = new Date(start);
    result.setDate(result.getDate() + days);
    return result;
  };

  const formatDateRange = (start, end) => {
    const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
    return sameMonth ? `${start.getDate()}–${formatDate(end)}` : `${formatDate(start)}–${formatDate(end)}`;
  };

  const initializeLiveViewers = () => {
    document.querySelectorAll('[data-live-viewers]').forEach((element) => {
      if (element.dataset.liveViewersReady === 'true') return;
      element.dataset.liveViewersReady = 'true';

      const countElement = element.querySelector('[data-live-viewer-count]');
      if (!countElement) return;

      // A figure that came from the product metafield is real data — show it as
      // published and never drift it.
      if (countElement.dataset.verified === 'true') return;

      // Use metafield value as base if provided, otherwise random 20–50
      const metaValue = parseInt(countElement.textContent, 10);
      let count = metaValue > 0 ? metaValue : Math.floor(Math.random() * 31) + 20;
      countElement.textContent = String(count);

      const tick = () => {
        if (!element.isConnected) return;

        const movement = Math.random() < 0.5 ? -1 : 1;
        count = Math.min(55, Math.max(15, count + movement));
        countElement.textContent = String(count);

        // Random interval between 2–5 seconds for realistic feel
        const delay = Math.floor(Math.random() * 3000) + 2000;
        window.setTimeout(tick, delay);
      };

      // First tick after 2–4 seconds
      window.setTimeout(tick, Math.floor(Math.random() * 2000) + 2000);
    });
  };

  const setTextIfChanged = (element, value) => {
    if (element.textContent !== value) element.textContent = value;
  };

  const updateProductPage = () => {
    const today = new Date();
    const shippingRange = formatDateRange(addDays(today, 1), addDays(today, 2));
    const deliveryRange = formatDateRange(addDays(today, 4), addDays(today, 6));

    document.querySelectorAll('[data-order-date]').forEach((element) => {
      setTextIfChanged(element, formatDate(today));
    });
    document.querySelectorAll('[data-shipping-range]').forEach((element) => {
      setTextIfChanged(element, shippingRange);
    });
    document.querySelectorAll('[data-delivery-range]').forEach((element) => {
      setTextIfChanged(element, deliveryRange);
    });
    document.querySelectorAll('[data-delivery-dates]').forEach((element) => {
      setTextIfChanged(element, deliveryRange);
    });

    document
      .querySelectorAll("[data-testid='product-information'] product-price, .sticky-add-to-cart__price")
      .forEach((priceContainer) => {
        const walker = document.createTreeWalker(priceContainer, NodeFilter.SHOW_TEXT);
        let textNode = walker.nextNode();

        while (textNode) {
          const normalizedValue = textNode.nodeValue.replace(/Rs\.?\s*/g, '₹');
          if (normalizedValue !== textNode.nodeValue) textNode.nodeValue = normalizedValue;
          textNode = walker.nextNode();
        }
      });

    const activePrice = document.querySelector("[data-testid='product-information'] product-price .price");
    const dockPrice = document.querySelector('[data-dc-dock-price]');
    if (activePrice && dockPrice) {
      const visiblePrice = activePrice.cloneNode(true);
      visiblePrice.querySelectorAll('.visually-hidden').forEach((label) => label.remove());
      const priceText = visiblePrice.textContent.replace(/\s+/g, ' ').trim();
      if (priceText && dockPrice.textContent !== priceText) dockPrice.textContent = priceText;
    }

    const activeVariant = document.querySelector(
      "[data-testid='product-information'] product-form-component input[name='id']"
    );
    const dockVariant = document.querySelector('[data-dc-dock-variant]');
    if (activeVariant && dockVariant && dockVariant.value !== activeVariant.value) {
      dockVariant.value = activeVariant.value;
    }

    const addonInput = document.querySelector('[data-product-addon]');
    const dockLabel = document.querySelector('[data-dc-dock-price-label]');
    const nativeCheckout = document.querySelector('[data-dc-native-checkout]');
    const addonCheckout = document.querySelector('[data-dc-addon-checkout]');
    const addonSelected = addonInput?.checked === true;

    if (addonSelected && activeVariant && dockPrice) {
      const basePrice = Number(activeVariant.dataset.variantPrice || 0);
      const addonPrice = Number(addonInput.dataset.addonPrice || 0);
      if (basePrice > 0 && addonPrice > 0) dockPrice.textContent = formatMoney(basePrice + addonPrice);
    }

    if (dockLabel) dockLabel.textContent = addonSelected ? 'Total' : 'Price';
    if (nativeCheckout) nativeCheckout.hidden = addonSelected;
    if (addonCheckout) addonCheckout.hidden = !addonSelected;
  };

  const initialize = () => {
    updateProductPage();
    initializeLiveViewers();

    const productInformation = document.querySelector("[data-testid='product-information']");
    if (!productInformation) return;

    const addonCheckout = document.querySelector('[data-dc-addon-checkout]');
    addonCheckout?.addEventListener('click', () => {
      const productForm = productInformation.querySelector('product-form-component');
      productForm?.handleAddonBuyNow?.();
    });

    let updateFrame;
    const scheduleProductPageUpdate = () => {
      if (updateFrame) return;

      updateFrame = requestAnimationFrame(() => {
        updateFrame = undefined;
        updateProductPage();
      });
    };

    new MutationObserver(scheduleProductPageUpdate).observe(productInformation, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    productInformation.addEventListener('change', scheduleProductPageUpdate);

    productInformation.querySelectorAll('[data-store-reviews-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const reviews = document.querySelector('#DcStoreReviews');
        if (!reviews) return;

        event.preventDefault();
        reviews.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });

        if (window.location.hash !== '#DcStoreReviews') {
          window.history.replaceState(null, '', '#DcStoreReviews');
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
